import styled from "@emotion/styled"
import { css } from '@emotion/react'

import facepaint from "facepaint"

const breakpoints = [440, 768, 1024, 1200, 1400]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const imageBg = ({ color }) => css({
  background: color === "red" ? "linear-gradient(266deg, #FA635A 7.5%, #F96674 37.58%)"
    : color === "indigo" ? "linear-gradient(249deg, #83A0FF 0%, #B872D2 103.81%)"
    : color === "green" ? "linear-gradient(249deg, #5DC53B 0%, #26B789 97.98%)"
    : color === "blue" && "linear-gradient(249deg, #83AEFF 0%, #3DCDE0 103.81%)",
})

export const ImageBg = styled.div`
  position: sticky;
  top: 112px;
  display: flex;
  align-self: start;
  justify-content: center;
  width: 100%;
  max-width: 860px;
  border-radius: 16px;
  overflow: hidden;

  & > img {
    height: auto;
    border-radius: 16px;
    background: var(--color-white);
    box-shadow: var(--elevation-light-high);
  }
  ${imageBg}
`

const imageCustomFieldsMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "45px 16px", // 768+
  ],
}))

export const ImageCustomFields = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageCustomFieldsMQ}
`

const imageDynamicTextsMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "70px 16px", // 768+
  ],
}))

export const ImageDynamicTexts = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageDynamicTextsMQ}
`

const imageSharingQuickActionsMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "150px 16px 172px", // 768+
  ],
}))

export const ImageSharingQuickActions = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageSharingQuickActionsMQ}
`

const imageMagicLinksMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "45px 16px", // 768+
  ],
}))

export const ImageMagicLinks = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageMagicLinksMQ}
`

const imageFormTemplatesMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "80px 16px", // 768+
  ],
}))

export const ImageFormTemplates = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageFormTemplatesMQ}
`

const imageDocumentsMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "52px 16px", // 768+
  ],
}))

export const ImageDocuments = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageDocumentsMQ}
`

const imageTaskDependenciesMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "55px 16px", // 768+
  ],
}))

export const ImageTaskDependencies = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageTaskDependenciesMQ}
`

const imageChecklistsMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "124px 16px", // 768+
  ],
}))

export const ImageChecklists = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageChecklistsMQ}
`

const imageAdvancedFiltersMQ = css(mq({
  margin: [
    "16px 0 0 16px", // 0+
    "16px 0 0 16px", // 440+
    "24px 0 0 24px", // 768+
    "60px 0 0 60px", // 1024+
  ],
  maxWidth: [
    "calc(100% - 16px)", // 0+
    "calc(100% - 16px)", // 440+
    "calc(100% - 24px)", // 768+
    "calc(100% - 60px)", // 1024+
  ],
}))

export const ImageAdvancedFilters = styled.img`
  border-radius: 16px 0 0 0!important;
  ${imageAdvancedFiltersMQ}
`

const imageAdvancedGroupingMQ = css(mq({
  margin: [
    "16px 0 0 16px", // 0+
    "16px 0 0 16px", // 440+
    "24px 0 0 24px", // 768+
    "60px 0 0 60px", // 1024+
  ],
  maxWidth: [
    "calc(100% - 16px)", // 0+
    "calc(100% - 16px)", // 440+
    "calc(100% - 24px)", // 768+
    "calc(100% - 60px)", // 1024+
  ],
}))

export const ImageAdvancedGrouping = styled.img`
  border-radius: 16px 0 0 0!important;
  ${imageAdvancedGroupingMQ}
`

const imageSlackCanvasesMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "55px 16px", // 768+
  ],
}))

export const ImageSlackCanvases = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageSlackCanvasesMQ}
`

const imageInternalTasksMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "120px 16px 100px", // 768+
  ],
}))

export const ImageInternalTasks = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageInternalTasksMQ}
`

const imageInternalCommunicationMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "85px 16px", // 768+
  ],
}))

export const ImageInternalCommunication = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageInternalCommunicationMQ}
`

const imageWeeklyUpdatesMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "45px 16px", // 768+
  ],
}))

export const ImageWeeklyUpdates = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageWeeklyUpdatesMQ}
`

const imagePersonalViewsMQ = css(mq({
  margin: [
    "16px 0 0 16px", // 0+
    "16px 0 0 16px", // 440+
    "24px 0 0 24px", // 768+
    "60px 0 0 60px", // 1024+
  ],
  maxWidth: [
    "calc(100% - 16px)", // 0+
    "calc(100% - 16px)", // 440+
    "calc(100% - 24px)", // 768+
    "calc(100% - 60px)", // 1024+
  ],
}))

export const ImagePersonalViews = styled.img`
  border-radius: 16px 0 0 0!important;
  ${imagePersonalViewsMQ}
`

const imageAccountsManagementMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "80px 16px", // 768+
  ],
}))

export const ImageAccountsManagement = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageAccountsManagementMQ}
`

const imageTimeTrackingMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "61px 16px 61px", // 768+
  ],
}))

export const ImageTimeTracking = styled.img`
  background: none!important;
  box-shadow: none!important;
  max-width: calc(100% - 16px - 16px);
  ${imageTimeTrackingMQ}
`

const imageHighlightingFieldsMQ = css(mq({
  margin: [
    "16px 0 0 16px", // 0+
    "16px 0 0 16px", // 440+
    "24px 0 0 24px", // 768+
    "60px 0 0 60px", // 1024+
  ],
  maxWidth: [
    "calc(100% - 16px)", // 0+
    "calc(100% - 16px)", // 440+
    "calc(100% - 24px)", // 768+
    "calc(100% - 60px)", // 1024+
  ],
}))

export const ImageHighlightingFields = styled.img`
  border-radius: 16px 0 0 0!important;
  ${imageHighlightingFieldsMQ}
`

const imageBrandedPortalMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "58px 16px", // 768+
  ],
}))

export const ImageBrandedPortal = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageBrandedPortalMQ}
`

const imageDarkModeMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "94px 16px", // 768+
  ],
}))

export const ImageDarkMode = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageDarkModeMQ}
`

const imageApiMQ = css(mq({
  margin: [
    "16px 16px", // 0+
    "16px 16px", // 440+
    "72px 16px", // 768+
  ],
}))

export const ImageApi = styled.img`
  max-width: calc(100% - 16px - 16px);
  ${imageApiMQ}
`
